import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import './FAQ.css';

const FAQ = () => {
  const [openItems, setOpenItems] = useState({});

  const toggleItem = (index) => {
    setOpenItems(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  const faqData = [
    {
      question: "Mitä palveluita Sipelius Kotipalvelu tarjoaa?",
      answer: "Tarjoan kattavat kotipalvelut ja senioripalvelut Lahdessa, Hollolassa, Heinolassa ja Orimattilassa: kotisiivous, senioriapu, henkilökohtainen apu, piha- ja puutarhatyöt sekä viriketoiminta. Palvelut sopivat niin senioreille kuin kiireisille lapsiperheille ja kaikille, jotka tarvitsevat apua arjen askareissa."
    },
    {
      question: "Paljonko palvelut maksavat?",
      answer: "Kaikki palveluni ovat saatavilla 38€/tunti. Senioreille tarjoan mahdollisuuden ALV 0% -palvelusopimukseen. Lahden kaupunkialueen ulkopuolella veloitan kilometrikorvauksen 0,59€/km."
    },
    {
      question: "Millä alueella toimit?",
      answer: "Toimin Lahdessa, Hollolassa, Heinolassa ja Orimattilassa. Lahden kaupunkialueen ulkopuolella veloitan matkakulut kilometrikorvauksena."
    },
    {
      question: "Oletko koulutettu ja vakuutettu?",
      answer: "Olen laillistettu lähihoitaja ja toimintani on vastuuvakuutettu. Minulla on pitkä kokemus kotihoidosta eri puolilta Suomea."
    },
    {
      question: "Miten voin varata ajan?",
      answer: "Voit ottaa yhteyttä puhelimitse numeroon 044 246 5506 tai sähköpostitse osoitteeseen sipeliuskotipalvelu@gmail.com. Tarjoan ilmaisen arviointikäynnin."
    },
    {
      question: "Mitä maksutapoja hyväksyt?",
      answer: "Voit maksaa palveluni sähköpostilaskulla, perinteisellä paperilaskulla tai käteisellä."
    },
    {
      question: "Milloin olet käytettävissä?",
      answer: "Työaikani ovat maanantaista perjantaihin klo 7:00-18:00. Viikonloppuisin toimin sopimuksen mukaan."
    },
    {
      question: "Mikä erottaa sinut muista kotipalveluyrityksistä?",
      answer: "Kun valitset minut, saat aina palvelua suoraan minulta itseltäni - ei vaihtuvia työntekijöitä. Tarjoan yksilöllistä, luotettavaa palvelua suomeksi ja räätälöin palvelut juuri sinun tarpeidesi mukaan."
    },
    {
      question: "Mitä senioripalveluita tarjoat Lahdessa ja lähikunnissa?",
      answer: "Senioripalveluni Lahdessa, Hollolassa, Heinolassa ja Orimattilassa kattavat monipuolisen senioriapu-kokonaisuuden: peseytymisapu, pukeutumisapu, asiointiavustus, seuranpito, ruoanvalmistus, lääkärikäynnit ja digiohjaus. Kaikki senioripalvelut räätälöidään yksilöllisesti asiakkaan tarpeiden mukaan."
    }
  ];

  const faqStructuredData = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqData.map(item => ({
      "@type": "Question",
      "name": item.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": item.answer
      }
    }))
  };

  return (
    <section className="faq-section">
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(faqStructuredData)}
        </script>
      </Helmet>
      <div className="container">
        <div className="faq-header">
          <h2>Usein kysytyt kysymykset</h2>
          <p>Löydät vastaukset yleisimpiin kysymyksiin kotipalveluistani</p>
        </div>
        
        <div className="faq-list">
          {faqData.map((item, index) => (
            <div key={index} className={`faq-item ${openItems[index] ? 'open' : ''}`}>
              <button 
                className="faq-question"
                onClick={() => toggleItem(index)}
                aria-expanded={openItems[index]}
                aria-controls={`faq-answer-${index}`}
              >
                <h3>{item.question}</h3>
                <span className="faq-icon" aria-hidden="true">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4 6L8 10L12 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </span>
              </button>
              <div 
                id={`faq-answer-${index}`}
                className="faq-answer"
                aria-hidden={!openItems[index]}
              >
                <p>{item.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
